import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { useConstatValidateOrRefuseMutation } from "../../../features/api/apiSlice";
import { ConstatValidatePostValues } from "../../../types/constats";
import { getErrorMessage } from "../../../utils/errors/errors";
import { FormEventValidateSchema } from "./FormEventValidate";

export default function useSubmitValidateConstat({
  id: constatId,
  onSuccess,
}: {
  id: number;
  onSuccess: () => void;
}) {
  const [validateOrRefuse, { isLoading: isValidating }] =
    useConstatValidateOrRefuseMutation();

  const onSubmit: SubmitHandler<FormEventValidateSchema> = useCallback(
    async (values) => {
      try {
        const formattedValues: ConstatValidatePostValues & {
          validateOrRefuse: "validate" | "refused";
        } = {
          constatId,
          validateOrRefuse: values.validateOrRefuse,
          comment: values.comment?.trim() || "",
        };

        const payload = await validateOrRefuse(formattedValues).unwrap();
        console.log("Response validateOrRefuse", payload);

        notification.success({
          message: `Le constat a bien Ã©tÃ© ${formattedValues.validateOrRefuse === "validate" ? "clÃ´turÃ©" : "refusÃ©"}.`,
        });

        onSuccess();
      } catch (error) {
        console.error("Error validateOrRefuse", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [constatId, onSuccess, validateOrRefuse],
  );

  return {
    onSubmit,
    isLoading: isValidating,
  };
}
